import React from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import AlertModal from '../../ReactComponent/Modal/AlertModal';
import { P } from '../../../theme/typographySitecore';
import PrimaryButton, { styleTypes } from '../../ReactComponent/PrimaryButton';
import ButtonGroup from './css';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';

const ResetFormModal = ({
  isOpen, onClose, parentFields, onReset,
}) => {
  const header = () => (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{parentFields.resetFormModalHeader.value}</>
  );

  const content = () => (
    <P field={parentFields.resetFormModalBody} />
  );

  const actions = () => (
    <ButtonGroup>
      <SecondaryButton
        type="button"
        smallWidth
        showArrow={false}
        styleType={styleTypes.SECONDARY}
        onClick={onClose}
      >
        {t('Cancel')}
      </SecondaryButton>

      <PrimaryButton
        type="button"
        smallWidth
        iconRightArrow
        onClick={() => { onReset(); onClose(); }}
      >
        {t('Reset')}
      </PrimaryButton>
    </ButtonGroup>
  );

  return (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      content={content}
      actions={actions}
    />
  );
};

ResetFormModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  parentFields: PropTypes.shape({
    resetFormModalHeader: PropTypes.shape({
      value: PropTypes.string,
    }),
    resetFormModalBody: PropTypes.object,
  }),
  onReset: PropTypes.func,
};

export default ResetFormModal;
